import React from 'react';
import { profile } from '../data/profile';
interface PortraitFrameProps {
  className?: string;
}
function CornerOrnament({
  className
}: {
  className: string;
}) {
  return <span aria-hidden="true" className={`pointer-events-none absolute ${className}`} data-id="element-89" data-mp="1pik4ehaqys26">
      <span className="block h-5 w-5 rotate-45 border border-gold-soft/70 bg-navy" data-id="element-90" data-mp="1pkdd024x7mct" />
    </span>;
}

/**
 * An engraved, certificate-style frame: navy matte, double gold rule,
 * mitred corner diamonds, and a monogram plate beneath the portrait.
 */
export function PortraitFrame({
  className = ''
}: PortraitFrameProps) {
  return <figure className={`relative ${className}`} data-id="element-91" data-mp="28gwbzym0ftvn">
      {/* Outer plate */}
      <div className="relative border border-gold/50 bg-navy p-2.5 shadow-[0_28px_70px_-40px_rgba(15,23,42,0.85)]" data-id="element-92" data-mp="23ibe45u8dmad">
        {/* Inner double rule */}
        <div className="relative border border-gold-soft/35 p-1" data-id="element-93" data-mp="30yh3uzg7oudn">
          <div className="relative border border-gold-soft/20 bg-navy-700 p-5" data-id="element-94" data-mp="2w6gzmut3zfb9">
            {/* Matte */}
            <div className="relative overflow-hidden border border-white/10" data-id="element-95" data-mp="1nix5k1ebixja">
              <img src={profile.portrait} alt="Portrait of Keith Kohl" className="block aspect-[4/5] w-full object-cover object-top" loading="eager" data-id="element-96" data-mp="1si0cxshrtfuf" />
            </div>

            {/* Engraved plate */}
            <div className="mt-5 border-t border-gold-soft/30 pt-4 text-center" data-id="element-97" data-mp="1iq42rj2etz9u">
              <span className="font-display text-[13px] uppercase tracking-overline text-gold-soft" data-id="element-98" data-mp="14re4i03uttjw">
                K · D · K
              </span>
            </div>
          </div>
        </div>

        <CornerOrnament className="-left-2.5 -top-2.5" data-id="element-99" data-mp="uwcg56hekvid" />
        <CornerOrnament className="-right-2.5 -top-2.5" data-id="element-100" data-mp="zst2pw8yf1tc" />
        <CornerOrnament className="-bottom-2.5 -left-2.5" data-id="element-101" data-mp="zvp3rtg3m6m0" />
        <CornerOrnament className="-bottom-2.5 -right-2.5" data-id="element-102" data-mp="2p9u6f19706h3" />
      </div>
    </figure>;
}